import * as React from "react";
import { Box, Layer, LayerPositionType } from "grommet";
import ScrollContainer from "./ScrollContainer";

const StyledModal = ({
    isOpen,
    setIsOpen,
    position,
    full,
    children,
}: {
    isOpen: boolean;
    setIsOpen?: Function;
    position?: LayerPositionType;
    full?: boolean | "vertical" | "horizontal";
    children: any;
}) => {
    if (isOpen)
        return (
            <Layer full={full === undefined ? "vertical" : full} position={position || "right"} responsive={true} onEsc={() => setIsOpen && setIsOpen(false)}>
                <ScrollContainer direction={"-y"}>
                    <Box pad="medium">{children}</Box>
                </ScrollContainer>
            </Layer>
        );

    return <></>;
};

export default StyledModal;
